/** Case-insensitive "does any of these texts contain the query" — the search every index page uses. */
export function matchesQuery(query: string, ...texts: (string | null | undefined)[]): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return texts.some((t) => !!t && t.toLowerCase().includes(q))
}
